import { Injectable } from "@angular/core";
import { ICharacteristicData } from "rl-common/models/i-characteristic-data";
import { RlHttpClient } from "../rl-http-client.service";



@Injectable({ providedIn: "root" })
export class ProductApprovalsService {

	constructor(
		private readonly _rlHttpClient: RlHttpClient
	) { }

	mergeFilesToPdf(charTypeID: number, templateID: number, charData: ICharacteristicData[]) {
		return this._rlHttpClient
			.post(`/product-approvals/merge-files-to-pdf`)
			.body({ charTypeID, templateID, charData })
			.fetch<ICharacteristicData[]>();
	}

}
